export const DeskTopHeaderContent = {
    CompanyCaption: `"Technology empowers us to dream beyond boundaries and make those dreams a reality."`,
    ContactInfo: "(516) 888-0089 Reachus@ravbs.com"
}
